import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { useUserStore } from '@gik/core/store/UserStore';
import { useHistoryClaims } from '@gik/api/users/claims';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import ClaimsListSkeleton from './ClaimsListSkeleton';
import ClaimsList from './ClaimsList';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '@gik/ui';
import { IUserProfileClaim } from '@gik/calendar/models/Claim';

export interface IHistoryClaimsListProps {
  items?: IUserProfileClaim[];
}

const blockName = 'claimed-items-list';

function HistoryClaimsList({ items }: IHistoryClaimsListProps) {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  const userStore = useUserStore();
  const { data: _items, error: _itemsError } = useHistoryClaims(userStore.id, { initialData: items });

  const isLoading = !_items;
  const isError = isLoading && _itemsError;

  if (isLoading) return <LoadingSpinner center />;
  if (isError) return <LoadingSpinner center />;

  return (
    <ClaimsList className={bem()} items={_items} loading={!_items} emptyText={t(translationKeys.emptyHistoryClaims)} />
  );
}

export default withSuspense(HistoryClaimsList, ClaimsListSkeleton);
